import i18n from '@/i18n'

export function getLocaleDateFormat(format) {
  if (['ru', 'en'].includes(i18n.locale)) {
    if (format === 'MM/DD/YYYY') return 'DD.MM.YYYY'
    if (format === 'YYYY/MM/DD') return 'DD.MM.YYYY'
    if (format === 'MM/DD') return 'DD.MM'
    if (format === 'MM/DD/YY') return 'DD.MM.YY'
    if (/YYYY\/MM\/DD/.test(format)) {
      return format.replaceAll('YYYY/MM/DD', 'DD.MM.YYYY')
    }
    if (/YYYY-MM-DD/.test(format)) {
      return format.replaceAll('YYYY-MM-DD', 'DD.MM.YYYY')
    }
  }
  return format
}
